export default __webpack_public_path__ + "assets/logos/85409fe919717853eb92e6d6c725bdc2.png";